/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import { slug } from '../../common';
import AchievementUnlockedNotification from './components/AchievementUnlockedNotification';
import NotificationGrid from 'flarum/forum/components/NotificationGrid';
import app from 'flarum/forum/app';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.settings`;

export default () => {
	app.notificationComponents.achievementUnlocked = AchievementUnlockedNotification;

	extend(NotificationGrid.prototype, 'notificationTypes', function (items) {
		if (!app.forum.attribute(`${slug}.gamification.enabled`)) {
			return;
		}

		items.add('achievementUnlocked', {
			name: 'achievementUnlocked',
			icon: 'fas fa-bullseye-arrow',
			label: t(`${prfx}.notify_achievement_unlocked`),
		});
	});
};
